import {ComponentType} from "react";
import {CustomDetector} from "i18next-browser-languagedetector";
import {Language} from "data/enums";
import {useLocation} from "react-router-dom";
import {IMAGES_URL} from "data/constants";

type Factory<T> = () => Promise<{
	default: ComponentType<T>;
}>;

export function retryFailLoad<T>(fn: Factory<T>, retriesLeft = 5, interval = 1000): Factory<T> {
	return () =>
		new Promise((resolve, reject) => {
			fn()
				.then(resolve)
				.catch((error: unknown) => {
					setTimeout(() => {
						if (retriesLeft === 1) {
							reject(error);
							return;
						}

						retryFailLoad(fn, retriesLeft - 1, interval)().then(resolve, reject);
					}, interval);
				});
		});
}

export const languageDetectorByUrl = {
	name: "languageDetectorByUrl",

	lookup() {
		if (window.location.origin.includes("lcf")) {
			return Language.French;
		}

		return Language.English;
	},
} as CustomDetector;

export const useLinkClassName = (href: string) => {
	const {pathname} = useLocation();
	const isActive = pathname === href;
	return isActive ? "active" : "";
};

export const getAvatarUrl = (squadShortName: string) =>
	process.env.REACT_APP_ENVIRONMENT === "uat"
		? `${IMAGES_URL}logo/${squadShortName}.webp`
		: `${IMAGES_URL}logo/${squadShortName}.svg`;
export const getVideoUrl = (videoName: string) => `${IMAGES_URL}video/${videoName}`;

export const redirectByBrowserLanguage = () => {
	if (
		(/^fr\b/.test(navigator.language) && process.env.REACT_APP_VERSION === "en") ||
		(/^en\b/.test(navigator.language) && process.env.REACT_APP_VERSION === "fr")
	) {
		window.location.href = process.env.REACT_APP_OTHER_PICKEM_LINK || "";
	}
};

export * from "./getLogo";
export * from "./connextraScript";
